import { render } from "./ExpiredPaymentInfo.vue?vue&type=template&id=a0a4da0a&scoped=true"
import script from "./ExpiredPaymentInfo.vue?vue&type=script&lang=js"
export * from "./ExpiredPaymentInfo.vue?vue&type=script&lang=js"

import "./ExpiredPaymentInfo.vue?vue&type=style&index=0&id=a0a4da0a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0a4da0a"]])

export default __exports__